<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <template v-slot:header>
                <h5>Nasabah Pekerjaan</h5>
            </template>
            <div class="search-wrapper d-flex align-items-center justify-content-between">
                <b-form-group
                    label="Filter"
                    label-for="filterInput"
                    class="form-inline form-group-wrapper mb-3"
                >
                    <div class="d-flex search-input-wrapper">
                        <b-form-input class="ml-2 mr-2"
                            v-model="input.filterName" name="filterTable"
                            id="filterInput"
                            type="search"
                            placeholder="Type to search"
                            @keyup="getPekerjaan()"
                        ></b-form-input>
                        <!-- <b-button class="mr-2" variant="pgiBtn" name="searchTableBtn" :disabled="isBusy" @click="getPekerjaan"> 
                            <i class="fa fa-search"></i>
                        </b-button> -->
                        <b-button variant="pgiBtn" name="resetTableBtn" :disabled="isBusy" @click="onReset()">Reset</b-button>
                    </div>
                </b-form-group>
                <b-button class="mb-3" variant="pgiBtn" name="roleAddBtn" @click="inputPekerjaan">Input Pekerjaan</b-button>
            </div>
            <b-table bordered hover show-empty
                :busy="isBusy"
                :items="pekerjaan" 
                :fields="fields"
                responsive class="mb-3">
                <template v-slot:table-busy>
                    <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>  Loading data...</strong>
                    </div>
                </template>
                <template v-slot:empty>
                    Tidak ada data Pekerjaan.
                </template>
                <template v-slot:cell(action)="row">
                    <div class="no-wrap">
                        <b-button size="sm" class="table-button edit" v-b-tooltip.hover title="Edit" name="userStaffEditBtn" @click="editPekerjaan(row.item)">
                            <i class="fa fa-pencil-square-o"></i>
                        </b-button>
                    </div>
                </template>
            </b-table>

            <div class="pagination-wrapper d-flex align-items-center justify-content-between">
                <b-input-group prepend="Tampilkan" class="align-items-center tableShowItem">
                    <b-form-select v-model="input.show" id="showItems" :options="options" @change="onLimitChange">
                        <template v-slot:first>
                            <b-form-select-option :value="null" disabled />
                        </template>
                    </b-form-select>
                    <span class="ml-2">{{ totalViewText }}</span>
                </b-input-group>
                <b-pagination class="mb-0"
                    v-model="currentPage"
                    :total-rows="rows"
                    :per-page="perPage"
                    aria-controls="my-table"
                    @input="onPageChange"
                ></b-pagination>
            </div>

            <b-modal id="modal-tambah-pekerjaan" title="Tambah Pekerjaan">
                <b-form-group label="Nama Pekerjaan">
                        <b-form-input
                        v-model="form.pekerjaan"
                        placeholder="Masukan Nama Pekerjaan"
                        required
                        ></b-form-input>
                </b-form-group>

                <template v-slot:modal-footer="{ ok }">

                    <b-button variant="primary" name="submitBtn" @click="confirmInput" :disabled="isSubmitting">
                        {{ isSubmitting ? "Loading" : "Submit" }}
                    </b-button>
                </template>
            </b-modal>


            <b-modal id="modal-edit-pekerjaan" title="Ubah Pekerjaan">
                <b-form-group label="Nama Pekerjaan">
                        <b-form-input
                        v-model="formEdit.pekerjaan"
                        placeholder="Masukan Nama Pekerjaan"
                        required
                        ></b-form-input>
                </b-form-group>

                <template v-slot:modal-footer="{ ok }">
                    <b-button variant="primary" name="submitBtn" @click="confirmEdit" :disabled="isSubmitting">
                        {{ isSubmitting ? "Loading" : "Submit" }}
                    </b-button>
                </template>
            </b-modal>


            <ModalConfirm id="modal-confirm-input" title="Confirm input Pekerjaan" :isSubmitting="isSubmitting"
            desc="Apakah anda yakin untuk menginput pekerjaan ini?" @submit="submit" />

            <ModalConfirm id="modal-confirm-edit" title="Confirm ubah Pekerjaan" :isSubmitting="isSubmitting"
            desc="Apakah anda yakin untuk mengubah pekerjaan ini?" @submit="submitEdit" />

        </b-card>
    </div>
</template>

<script>
export default {
    name: 'master-pekerjaan',
    data(){
        return{
            initStatus: 0,
            isBusy: true,
            input:{
                show: 10,
                filterName: "",
            },
            form:{
                pekerjaan: ""
            },
            formEdit:{
                pekerjaan: ""
            },
            fields: [
                { key: "name", label: "Nama Posisi", sortable:true},
                { key: "action", label: "Aksi"}
            ],
            filter: null,
            options: [
                { value: 10, text: '10'},
                { value: 20, text: '20'},
                { value: 30, text: '30'},
                { value: 40, text: '40'},
                { value: 50, text: '50'},
            ],
          
            activeId : null,
            pekerjaan: [],
            currentPage: 1,
            perPage: 10,
            rows: null,
            totalViewText: "",
            page: '',
            size: '',
            loading: false,
            query: "",

            isSubmitting:false
        }
    }, 
    
    methods: {

        //----------------- Fungsi Inisialisasi -----------------

        init(){
            this.initStatus = 0
            this.page = 0
            this.size = this.input.show
            this.query = this.$helper.makeQuery(this.page, this.size)


            let getPekerjaan = this.$axios.get("nasabah-pekerjaan/"+this.query).then(response => {
                this.pekerjaan = response.data.data
                this.updateTotalItem(response.data.total)

                let msg = this.$helper.getFlash()
                this.$helper.toastSucc(this, msg)
            })

            Promise.all([getPekerjaan]).then(() => {
                this.initStatus = 1
                this.toggleBusy()
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
            })
        },


        //-----------------  Fungsi Ambil Data Role ----------------- 
        
        getPekerjaan(){
            this.toggleBusy()
      
            if(this.input.filterName != "")
            {
         
                this.query = this.$helper.makeQuery(this.page, this.size)
                this.loading = true
                this.query = this.query + "&filterName=" + this.input.filterName
            } 

            this.$axios.get("nasabah-pekerjaan/"+this.query).then(response => {
                this.pekerjaan = response.data.data
     
                this.toggleBusy()
                this.updateTotalItem(response.data.total)
                this.loading = false
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
                this.toggleBusy()
                this.loading = false
            })
        },


        //----------------- Fungsi Pagination, Sorting, dan Filtering -----------------

        onLimitChange(){
            this.size = this.input.show
            this.perPage = this.input.show
            this.currentPage = 1
            this.page = 0
            this.query = this.$helper.makeQuery(0, this.size)
            this.getPekerjaan()
        },

        onPageChange(){
            if (this.loading == false){

                this.page = this.currentPage - 1
                this.query = this.$helper.makeQuery(this.page, this.size)
                this.getPekerjaan()
            }
        },

        onReset(){
            this.input.filterName = ""
            this.currentPage = 1
            this.page = 0
            this.query = this.$helper.makeQuery(0, this.size)
            this.loading = true
            this.getPekerjaan()
        },

        //----------------- Fungsi Pindah Halaman dan Fungsi Lain -----------------

        toggleBusy(){
            if (this.isBusy == true) this.isBusy = false
            else this.isBusy = true
        },

         updateTotalItem(total){
            let limit = null
            let prevLimit = null
            this.perPage = this.size
            this.rows = total
            prevLimit = this.page * this.size + 1
            limit = this.page * this.size + this.size
            if (limit > this.rows) limit = this.rows
            this.totalViewText = "Menampilkan "+ prevLimit + " - " + limit + " dari " + this.rows + " entri"
        },

        inputPekerjaan(){
            this.$bvModal.show("modal-tambah-pekerjaan")
        },

        editPekerjaan(row){
    
            this.activeId = row.id
            this.formEdit.pekerjaan = row.name
            this.$bvModal.show("modal-edit-pekerjaan")
        },

        confirmInput(){
            if(this.form.pekerjaan == null || this.form.pekerjaan == ""){
                return this.$helper.toastErr(this, "Mohon isi Nama Pekerjaan terlebih dahulu!")
            }
            this.$bvModal.show("modal-confirm-input")
        },

        submit(){
            let payload = new FormData()
            payload.append("name", this.form.pekerjaan)

            this.$axios.post('nasabah-pekerjaan/', payload, { timeout: 300000 }).then(() => {
                this.form.pekerjaan = ""
                this.$helper.toastSucc(this, "Pekerjaan berhasil ditambahkan!")
                this.$bvModal.hide("modal-confirm-input")
                this.$bvModal.hide("modal-tambah-pekerjaan")
                this.getPekerjaan()
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
                this.isSubmitting = false
            })
            .finally(() => {
                // this.isSubmitting = false
            })

        },

        confirmEdit(){
            if(this.formEdit.pekerjaan == null || this.formEdit.pekerjaan == ""){
                return this.$helper.toastErr(this, "Mohon isi Nama Pekerjaan terlebih dahulu!")
            }
            this.$bvModal.show("modal-confirm-edit")
        },

        submitEdit(){
           
            let payload = new FormData()
            payload.append("id", this.activeId)
            payload.append("name", this.formEdit.pekerjaan)

            this.$axios.post('nasabah-pekerjaan/', payload, { timeout: 300000 }).then(() => {
                this.formEdit.pekerjaan = ""
                this.$helper.toastSucc(this, "Pekerjaan berhasil diubah!")
                this.$bvModal.hide("modal-confirm-edit")
                this.$bvModal.hide("modal-edit-pekerjaan")
                this.getPekerjaan()
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
                this.isSubmitting = false
            })
            .finally(() => {
                // this.isSubmitting = false
            })

        }
    },
    created(){
        this.init()
    }
}
</script>
